export const ENTER_KEY_CODE = 13;

export const SPACE_KEY_CODE = 32;

export const ESCAPE_KEY_CODE = 27;

export const TAB_KEY_CODE = 9;